/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { DateTime } from 'luxon';

export const FOREVER = 20000000;

export const sleepForever = async () => {
  await new Promise(r => setTimeout(r, FOREVER));
};

export const getTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const getLocalDateTime = (): DateTime => {
  return DateTime.local();
};
